import script from "./MainGabinetePage.vue?vue&type=script&setup=true&lang=js"
export * from "./MainGabinetePage.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/main.css?vue&type=style&index=0&id=32612321&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32612321"]])

export default __exports__